import PropTypes from 'prop-types';
import { Button, Flex, LockIcon, Paragraph, ShieldIcon } from '@cof/plastic-components';
import { styled } from 'styled-components';

import { isSafeConnectionUrl } from '../../utilities/isSafeConnectionUrl';

export const IconRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 1.6rem;
    &:last-child {
        margin-bottom: 0.8rem;
    }
`;

const IconBox = styled.div`
    background: ${({ $backgroundColour }: any) => $backgroundColour};
    border-radius: 8px;
    padding: 24px 16px 8px 16px;
    text-align: center;
`;

const ObLandingIconBox = ({
    iconBox,
    iconColour,
    connectionUrl,
    buttonFlexPaddingBottom,
    noThanksButton,
    Text,
    className
}: any) => {
    const safeConnectionUrl = isSafeConnectionUrl(connectionUrl) ? connectionUrl : undefined;

    return (
        // @ts-expect-error TS2769: No overload matches this call.
        <IconBox $backgroundColour={iconBox} className={className}>
            <Flex
                flexDirection={'column'}
                maxWidth="100%"
                alignItems={'center'}
                paddingBottom={buttonFlexPaddingBottom}
            >
                <Flex flexDirection={'column'} alignItems={'start'}>
                    <Flex flexDirection={'column'} alignSelf={['start', null, 'center']} paddingBottom="1.6rem">
                        {/* @ts-expect-error TS2769: No overload matches this call. */}
                        <IconRow paddingBottom={['0.8rem', null, '1.6rem']}>
                            <ShieldIcon color={iconColour} />
                            <Paragraph variant="dark" pb={0} pl={'xs'} data-qm-allow>
                                No impact on your credit score
                            </Paragraph>
                        </IconRow>
                        <IconRow>
                            <LockIcon color={iconColour} />
                            <Paragraph variant="dark" pb={0} pl={'xs'} data-qm-allow>
                                100% safe and secure
                            </Paragraph>
                        </IconRow>
                    </Flex>
                    <IconRow>
                        <Button
                            as="a"
                            data-qa-id="OB-get-started-button"
                            href={safeConnectionUrl}
                            minWidth="311px"
                            data-qm-allow
                        >
                            <Text path="LinkMyBankAccount" params={{ 'data-qm-allow': 'true' }} />
                        </Button>
                    </IconRow>
                </Flex>
                {noThanksButton}
            </Flex>
        </IconBox>
    );
};

ObLandingIconBox.propTypes = {
    iconBox: PropTypes.string.isRequired,
    iconColour: PropTypes.string.isRequired,
    connectionUrl: PropTypes.string,
    buttonFlexPaddingBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    noThanksButton: PropTypes.node,
    Text: PropTypes.func.isRequired,
    className: PropTypes.string
};

export default ObLandingIconBox;
